import { AtlassianProductHostingTypeValues as HostingType, MarketplaceAppPaymentModelValues, MarketplacePartnerTypeValues } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
import { useFeatureFlags } from '@atlassian/mpac-ui';
import { MarketplaceAppUtils } from '@atlassian/mpac-utils';
import React from 'react';
import Section, { SectionsWrapper } from "../../../Section";
import PaidViaPartnerPricing from "./PaidViaPartnerPricing/PaidViaPartnerPricing";
import PricingCalculator from "./PricingCalculator/PricingCalculator";
import PricingFAQs from "./PricingFAQs";
import PricingHeading from "./PricingHeading";
import PricingTiers from "./PricingTiers/PricingTiers";
export var Pricing = function Pricing(_ref) {
  var appId = _ref.appId,
      paymentModel = _ref.paymentModel,
      hosting = _ref.hosting,
      learnMoreUrl = _ref.learnMoreUrl,
      mpacBaseUrl = _ref.mpacBaseUrl;

  var _useFeatureFlags = useFeatureFlags(),
      freeStarterTier = _useFeatureFlags.freeStarterTier;

  if (paymentModel === MarketplaceAppPaymentModelValues.PaidViaPartner) {
    return /*#__PURE__*/React.createElement(PaidViaPartnerPricing, {
      hosting: hosting,
      learnMoreUrl: learnMoreUrl
    });
  }

  if (hosting === HostingType.Cloud && freeStarterTier) return /*#__PURE__*/React.createElement(PricingCalculator, {
    appId: appId,
    hosting: hosting,
    mpacBaseUrl: mpacBaseUrl
  });
  return /*#__PURE__*/React.createElement(PricingTiers, {
    appId: appId,
    hosting: hosting,
    mpacBaseUrl: mpacBaseUrl
  });
};

var PricingTab = function PricingTab(_ref2) {
  var appId = _ref2.appId,
      appKey = _ref2.appKey,
      compatibleProducts = _ref2.compatibleProducts,
      hasDataCenterVersion = _ref2.hasDataCenterVersion,
      hosting = _ref2.hosting,
      learnMoreUrl = _ref2.learnMoreUrl,
      marketingLabels = _ref2.marketingLabels,
      partnerType = _ref2.partnerType,
      paymentModel = _ref2.paymentModel,
      mpacBaseUrl = _ref2.mpacBaseUrl;
  return /*#__PURE__*/React.createElement(SectionsWrapper, null, /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(PricingHeading, {
    hosting: hosting
  }), /*#__PURE__*/React.createElement(Pricing, {
    appId: appId,
    paymentModel: paymentModel,
    hosting: hosting,
    learnMoreUrl: learnMoreUrl,
    mpacBaseUrl: mpacBaseUrl
  })), /*#__PURE__*/React.createElement(PricingFAQs, {
    paymentModel: paymentModel,
    hosting: hosting,
    marketingLabels: marketingLabels,
    compatibleProducts: compatibleProducts,
    serverSubscriptionApp: MarketplaceAppUtils.isServerSubscriptionApp(appKey),
    hasDataCenterVersion: hasDataCenterVersion,
    byAtlassian: partnerType === MarketplacePartnerTypeValues.AtlassianInternal
  }));
};

export default PricingTab;